import React from 'react';

const handlers = {
    players: {
        getSuggestions: (value, array) => {
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;
            return inputLength === 0 ? [] : array.filter(player =>
                `${player.firstName} ${player.lastName}`.toLowerCase().includes(inputValue) ||
                `${player.lastName} ${player.firstName}`.toLowerCase().includes(inputValue)
        ).slice(0,10)},
        getSuggestionValue: suggestion => `${suggestion.firstName} ${suggestion.lastName}`,
        renderSuggestion: suggestion => (
            <div>
              {`${suggestion.lastName}, ${suggestion.firstName} (${suggestion.position})`}
            </div>
        ),
    },
    simple: {
        getSuggestions: (value, array) => {
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;
            return inputLength === 0 ? [] : array.filter(league =>
               league.toLowerCase().includes(inputValue)
        ).slice(0,10)},
        getSuggestionValue: suggestion => suggestion,
        renderSuggestion: suggestion => (
            <div>
              {suggestion}
            </div>
        ),
    }
}

export default handlers;